export default {
    name: 'confirm-dialog',

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        intro: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            default: () => []
        },
        note: {
            type: String,
            default: ''
        },
        confirmText: {
            type: String,
            default: 'Confirm'
        },
        cancelText: {
            type: String,
            default: 'Cancel'
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/confirm-dialog/confirm-dialog.js